import { OpsType } from '@weave/schema-gen-ts/dist/shared/organization/ops_type.pb';
import { PaymentQueries } from '@frontend/api-payments';
import { useStripePromise } from './use-stripe-promise';

export const useWeaveAppStripe = (locationType: keyof typeof OpsType | undefined) => {
  const { data: stripeExpressKey } = PaymentQueries.useStripeExpressPublicKeyQuery(locationType);
  return useStripePromise({ stripeExpressKey });
};
